import React from "react";

function MenuLinks(props) {
  const {
    toggleSystemIcons,
    toggleSystemLocations,
    toggleCompanyIcons,
    toggleCompanyLocations,
  } = props;
  return (
    <div className="admin-links">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">System Icons</h5>
          <p className="card-text">Create, edit, or delete system icons.</p>
          <button onClick={toggleSystemIcons}>Open</button>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">System Location Types</h5>
          <p className="card-text">Create, edit, or delete location types.</p>
          <button onClick={toggleSystemLocations}>Open</button>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Company Specific Icons</h5>
          <p className="card-text">Create, edit, or delete company icons.</p>
          <button onClick={toggleCompanyIcons}>Open</button>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Company Specific Location Types</h5>
          <p className="card-text">
            Create, edit, or delete company location types.
          </p>
          <button onClick={toggleCompanyLocations}>Open</button>
        </div>
      </div>
    </div>
  );
}

export default MenuLinks;
